/**
 * @generated SignedSource<<a8e320373867852b91c714c2e9d17b03>>
 * @relayHash 2294edcb5be9066741118fdffa8dc429
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/418.0.0-2023-06-12T15:05:27.617Z/IsKlarnaEligibleQuery

import { ConcreteRequest, Query } from 'relay-runtime';
export type IsKlarnaEligibleQuery$variables = {
  amount?: string | null;
  itemId?: string | null;
  userCountry?: string | null;
  userCurrency?: string | null;
  userId?: string | null;
};
export type IsKlarnaEligibleQuery$data = {
  readonly viewer: {
    readonly item: {
      readonly isKlarnaEligible: boolean | null;
    } | null;
  };
};
export type IsKlarnaEligibleQuery = {
  response: IsKlarnaEligibleQuery$data;
  variables: IsKlarnaEligibleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "amount"
},
v1 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "itemId"
},
v2 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountry"
},
v3 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCurrency"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v5 = [
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemId"
  },
  {
    "kind": "Literal",
    "name": "pageType",
    "value": "PDP"
  }
],
v6 = {
  "alias": "isKlarnaEligible",
  "args": [
    {
      "kind": "Variable",
      "name": "amount",
      "variableName": "amount"
    },
    {
      "kind": "Variable",
      "name": "buyerId",
      "variableName": "userId"
    },
    {
      "kind": "Variable",
      "name": "currency",
      "variableName": "userCurrency"
    },
    {
      "kind": "Literal",
      "name": "paymentMethod",
      "value": "KLARNA"
    },
    {
      "kind": "Variable",
      "name": "userCountry",
      "variableName": "userCountry"
    }
  ],
  "kind": "ScalarField",
  "name": "isPaymentMethodEligible",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "IsKlarnaEligibleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "Item",
            "kind": "LinkedField",
            "name": "item",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "IsKlarnaEligibleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "Item",
            "kind": "LinkedField",
            "name": "item",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/418.0.0-2023-06-12T15:05:27.617Z/IsKlarnaEligibleQuery",
    "metadata": {},
    "name": "IsKlarnaEligibleQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "350c9c2db8e73a4f72118ddb493fe7b8";

export default node;
